import type { AutoErrorReportStatus } from "./AutoClientErrorReport";

export function IsAuthorizationError(error: any) {
    const status = error?.response?.status;
    const responseText = GetResponseText(error?.response?.data);

    if (status === 500) {
        return responseText.includes("Missing authorization token cookie");
    }

    if (status !== 401) {
        return false;
    }

    return [
        "Invalid token",
        "Invalid bearer token",
        "No cookies found. Please login again.",
        "Please login again.",
        "You are not authorized. Please login at",
    ].some((message) => responseText.includes(message));
}

function GetResponseText(data: unknown) {
    if (typeof data === "string") {
        return data;
    }

    try {
        return JSON.stringify(data) || "";
    } catch (_error) {
        return "";
    }
}

export function GetErrorSummary(error: any) {
    if (error?.response) {
        const responseData = error.response.data;
        const details =
            typeof responseData === "string"
                ? responseData
                : JSON.stringify(responseData, null, 2);

        return `HTTP ${error.response.status}\n${details}`;
    }

    if (error instanceof Error) {
        return error.toString();
    }

    try {
        return JSON.stringify(error, null, 2);
    } catch {
        return String(error);
    }
}

export function GetErrorDiagnostics(error: any) {
    if (error?.response || error instanceof Error) {
        return error.stack || "";
    }

    return "";
}

export function GetReportButtonText(
    reportStatus: "idle" | "sending" | "sent" | "failed"
) {
    if (reportStatus === "sending") return "Sending error report...";
    if (reportStatus === "sent") return "Error report sent";
    if (reportStatus === "failed") return "Unable to send error report";
    return "Send error report";
}

export function GetAutomaticReportStatusText(status: AutoErrorReportStatus) {
    if (status === "sending") {
        return "Automatically sending diagnostic report...";
    }

    if (status === "sent") {
        return "Automatic diagnostic report sent.";
    }

    return "Automatic report failed; use the button below to retry.";
}
